import { render, staticRenderFns } from "./ReportCollectionDetails.vue?vue&type=template&id=d461ee86&scoped=true&"
import script from "./ReportCollectionDetails.vue?vue&type=script&lang=js&"
export * from "./ReportCollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportCollectionDetails.vue?vue&type=style&index=0&id=d461ee86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d461ee86",
  null
  
)

export default component.exports